/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["#progressBar[_ngcontent-%COMP%]{position:fixed;height:1px;z-index:3}"];
export { styles as styles };

